/** Super-admin route paths. Mirrors the paths in AdminLayout's ADMIN_NAV_GROUPS. */
export const ADMIN_ROUTES = {
  root: '/super-admin',
  tenants: '/super-admin/tenants',
  exchangeRates: '/super-admin/exchange-rates',
  emailSettings: '/super-admin/email-settings',
  emailTemplates: '/super-admin/email-templates',
  storageProfiles: '/super-admin/storage-profiles',
  storageMigrations: '/super-admin/storage-migrations',
  storageOverview: '/super-admin/storage-overview',
  appCatalogSuggestions: '/super-admin/app-catalog/suggestions',
  appCatalogRoadmap: '/super-admin/app-catalog/roadmap',
  appstore: '/super-admin/appstore',
  appstorePolicies: '/super-admin/appstore/policies',
  appstorePackaging: '/super-admin/appstore/packaging',
  marketplaceStores: '/super-admin/marketplace-stores',
  marketplaceCatalog: '/super-admin/marketplace-catalog',
  billingSettings: '/super-admin/billing-settings',
} as const;
